import { useEffect } from "react";
import { useCustomerStore } from "@/store";
import { type LocalePreference, type ResolvedLocale } from "@njbsoft/store";
import { i18n } from "@njbsoft/i18n";

function getSystemLocale(): ResolvedLocale {
  if (typeof window === "undefined") return "en";
  return navigator.language.startsWith("es") ? "es" : "en";
}

function resolveLocale(pref: LocalePreference): ResolvedLocale {
  if (pref === "en" || pref === "es") return pref;
  return getSystemLocale();
}

/**
 * Applies the persisted locale preference: the store's resolved locale, the
 * i18n language and `<html lang>`, so assistive tech reads the page in the
 * language it is written in. `index.html` ships `lang="en"` until this runs.
 */
export function useLocaleSync() {
  const localePreference = useCustomerStore((s) => s.localePreference);
  const setResolvedLocale = useCustomerStore((s) => s.setResolvedLocale);

  useEffect(() => {
    const resolved = resolveLocale(localePreference);
    setResolvedLocale(resolved);
    void i18n.changeLanguage(resolved);
    document.documentElement.lang = resolved;
  }, [localePreference, setResolvedLocale]);
}
